import { useMutation } from "react-query";
import { createApiWithPath } from "../../client";
import {
  CreateFieldTypePayload,
  FieldTypeResponseData,
} from "../../types/field-type";

const createFieldType = async (
  payload: CreateFieldTypePayload,
): Promise<FieldTypeResponseData> => {
  const { data } = await createApiWithPath("crm").post("/field-types", payload);
  return data;
};

export const useCreateFieldType = () => {
  return useMutation({
    mutationFn: (payload: CreateFieldTypePayload) => createFieldType(payload),
  });
};
